import { adminHttpClient } from '../../../../../commons/adminHttpClient'

export type UpdateReimbursementProduct = {
  productClassId: string
  reimbursementProduct: number
  notificationId: string
}

const updateReimbursementProduct = (request: UpdateReimbursementProduct): Promise<void> => {
  return adminHttpClient.put('AdminDashboard/Benefit/ShowPopupForPremiumPlus', request)
}

export default updateReimbursementProduct
